import { Component, Input } from '@angular/core';
import { getFileExtension, humanizeType } from 'src/app/kuba/shared/helpers/file.helper';

@Component({
  selector: 'document-preview',
  templateUrl: './document-preview.component.html',
  standalone: false
})
export class DocumentPreviewComponent {
  @Input() path: string;
  @Input() filename: string;
  @Input() documentId: number;
  @Input() isArticle: boolean;
  @Input() documentType: string;

  get fileType(): string {
    return humanizeType(getFileExtension(this.path));
  }

  get extension(): string {
    return getFileExtension(this.filename);
  }
}
